export const ImageCellRenderer = ({ value }) => {
  return <img src={value} alt="" style={{ height: '100%', width: '100%', objectFit: 'contain' }} />;
};
